module.exports = __webpack_public_path__ + "static/media/img-feature-slider-1@3x.49082674.png";